import { createSlice } from '@reduxjs/toolkit';

// types
import { SnackbarProps } from 'types/snackbar';

const initialState: SnackbarProps = {
    message: '',
    variant: 'default',
    duration: undefined,
    key: new Date().getTime()
};

// ==============================|| SLICE - SNACKBAR ||============================== //

const snackbar = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        openSnackbar(state, action) {
            const { message, variant, duration } = action.payload;

            state.message = message || initialState.message;
            state.variant = variant || initialState.variant;
            state.duration = duration || initialState.duration;
            state.key = new Date().getTime() + Math.random();
        }
    }
});

export default snackbar.reducer;

export const { openSnackbar } = snackbar.actions;
